<script setup lang="ts">
const props = defineProps({
  file: null,
  ghosted: { type: Boolean }
})

const { isSelectedIn } = useSelection()
const { state: clipboardState } = useClipboard()
const { fileIdAttr } = useGlobals()
const { state } = useGalleryView()
const container = useTemplateRef("container")

const selected = computed(() => isSelectedIn(props.file.fileId, 'collection-view'))
const ghosted = computed(() => state.value.currentFileId === props.file.fileId)
const height = computed(() => container.value?.getBoundingClientRect().height ?? 0)
const cut = computed(() => clipboardState.value.action === "cut"
  ? clipboardState.value.files[props.file.fileId]
  : undefined,
)
</script>

<template>
  <div
    ref="container"
    :[dataAttr(fileIdAttr)]="file.fileId"
    class="gallery-file"
  >
    <div
      v-if="height"
      class="gallery-file-container"
      :class="{ cut }"
      :style="{ height: px(height), width: px(height) }"
    >
      <file-thumbnail
        :file
        shadowed
        :selected
        :ghosted
        :container-width="height"
        :container-height="height"
        class="gallery-file-thumbnail"
      />
    </div>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.gallery-file
  @apply flex-none cursor-pointer h-full
.gallery-file-container
  @apply aspect-square h-full items-center justify-center flex
.gallery-file-thumbnail
  @apply max-h-full max-w-full rounded-sm
.gallery-file-properties
  @apply flex flex-col gap-[#{$page-properties-gap-file}]
.gallery-file-property
  @apply w-full flex items-center
.gallery-file.decal
  @apply flex-none
// If the file was cut before pasting
.cut
  @apply opacity-25
</style>
